export default {
  'delegationConfigurations.title': 'Configuraciones',
  'delegationConfigurations.description':
    'Configura entornos, procesos y usuarios delegados para esta delegación.',

  'delegationConfigurations.form.environment': 'Entorno',
  'delegationConfigurations.form.process': 'Proceso',
  'delegationConfigurations.form.name': 'Usuario delegado',
};
